import { colorStrings, mediaQueriesBP } from "@hardware/Utilities/variables";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Checkbox from "@insite/mobius/Checkbox";
import CheckboxGroup from "@insite/mobius/CheckboxGroup";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

const enum fields {
    checkboxLabel1 = "checkboxLabel1",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.checkboxLabel1]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    wantToKnowMore: state.components.contactUsForm.fieldValues["wantToKnowMore"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface WantToKnowMoreStyles {
    checkboxstyle?: InjectableCss;
    checkboxwrapper?: InjectableCss;
}

export const wantToKnowMoreStyles: WantToKnowMoreStyles = {
    checkboxwrapper:{
        css: css`
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            margin: 0 -15px 15px;
            flex-wrap: wrap;
            padding: 0 15px;
        `,
    },
    checkboxstyle: {
        css: css`
            margin-top: 0 !important;
            width: 100%;
        `,
    },
};

const styles = wantToKnowMoreStyles;

const WantToKnowMore: React.FC<Props> = ({ fields, setFieldValue }) => {
    const { checkboxLabel1 } = fields;
    const [isWantToKnowMore, setWantToKnowMore] = React.useState(false);

    React.useEffect(() => {
        setFieldValue({ key: "wantToKnowMore", value: isWantToKnowMore.toString() });
    },[isWantToKnowMore])

    return (
        <StyledWrapper>
            <CheckboxGroup {...styles.checkboxwrapper}>
                <Checkbox {...styles.checkboxstyle} 
                onChange={(e, value) => setWantToKnowMore(value)} 
                checked={isWantToKnowMore}>
                    {checkboxLabel1}
                </Checkbox>
            </CheckboxGroup>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(WantToKnowMore),
    definition: {
        group: "Contact Us",
        icon: "input-pipe",
        fieldDefinitions: [
            {
                name: fields.checkboxLabel1,
                displayName: "Checkbox Label 1",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Yes, I want to know more about Managed Inventory Programs",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
